import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';
import { formatViews } from '@/utils/movie';
import { useFavorites } from '@/hooks/useFavorites';

interface MovieCardProps {
  movie: Movie;
  showFavorite?: boolean;
}

export default function MovieCard({ movie, showFavorite = true }: MovieCardProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const favorited = isFavorite(movie.id);

  const handleFavorite = (e: React.MouseEvent) => {
    e.preventDefault();
    toggleFavorite(movie.id);
  };

  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200 border border-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 封面`}
          title={`${movie.title} - 亚洲中文字幕在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
        <span className="absolute top-2 left-2 px-2 h-6 flex items-center rounded-md bg-background-950/70 text-primary-400 text-xs font-label tracking-wide backdrop-blur">
          <i className="ri-star-fill mr-1 text-[10px]"></i>
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute top-2 right-2 px-2 h-6 flex items-center rounded-md bg-primary-500 text-background-950 text-xs font-medium">
          {movie.type === 'movie' ? '电影' : '剧集'}
        </span>
        {showFavorite && (
          <button
            type="button"
            onClick={handleFavorite}
            aria-label={favorited ? '取消收藏' : '收藏'}
            className={`absolute bottom-2 right-2 w-8 h-8 flex items-center justify-center rounded-md backdrop-blur cursor-pointer transition-colors ${
              favorited ? 'bg-accent-500 text-background-50' : 'bg-background-950/60 text-foreground-800 hover:bg-background-950/80'
            }`}
          >
            <i className={favorited ? 'ri-heart-fill' : 'ri-heart-line'}></i>
          </button>
        )}
      </div>
      <div className="mt-2">
        <h3 className="text-sm font-medium text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {movie.region} · {movie.year} · {movie.genres.slice(0, 2).join('/')}
        </p>
        <p className="mt-1 text-xs text-foreground-500 flex items-center gap-1">
          <i className="ri-fire-line text-accent-500"></i>
          {formatViews(movie.views)} 次播放
        </p>
      </div>
    </Link>
  );
}